var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { getCurrentProvider, getPatientMedicationByAuthSystem, getPatientMedicationById } from '../Async/MedicationsSummaryAsync';
import { UseAsyncStatus, useAsync } from '../Hooks/useAsync';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { EditMedicationDialog } from './EditMedicationDialog';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import styles from './EditMedicationLoader.module.css';
import { LayoutCentral } from '../Components/LayoutCentral';
import { ColorLinearProgress } from '../Components/ColorLinearProgress';
export var EditMedicationLoader = function (props) {
    var httpConfig = useHttpConfig();
    var httpProviderConfig = useHttpConfig();
    var patientMedicationAsync = useAsync({
        httpConfig: httpConfig,
        getApi: typeof props.patientMedicationId == 'string' ? getPatientMedicationById : getPatientMedicationByAuthSystem
    });
    var currentProviderAsync = useAsync({
        httpConfig: httpProviderConfig,
        getApi: getCurrentProvider
    });
    function getMedication() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (typeof props.patientMedicationId == 'string')
                        patientMedicationAsync.getApi(props.patientMedicationId);
                    else
                        patientMedicationAsync.getApi(props.patientMedicationId.authoringSystem, props.patientMedicationId.authoringSystemForeignKey);
                }
                catch (err) {
                    console.error(err);
                }
                return [2 /*return*/];
            });
        });
    }
    function getCurrentProviderInfo() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    currentProviderAsync.getApi(props.service.authoringSystem, props.service.authoringSystemForeignKey);
                }
                catch (err) {
                    console.error(err);
                }
                return [2 /*return*/];
            });
        });
    }
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var timeout;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timeout = new Promise(function (resolve) { return setTimeout(resolve, 1000); });
                    return [4 /*yield*/, Promise.all([getMedication(), getCurrentProviderInfo(), timeout])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        init();
    }, []);
    var patientMedication = patientMedicationAsync.data;
    var currentProvider = currentProviderAsync.data;
    var loadingPlaceholder = currentProviderAsync.status !== UseAsyncStatus.Loaded ||
        patientMedicationAsync.status !== UseAsyncStatus.Loaded ||
        patientMedication === null;
    return loadingPlaceholder ? (React.createElement(StyledDialog, { open: true, size: 'xxs', modal: true, testId: 'loading-medication', contentComponent: React.createElement(LayoutCentral, null,
            React.createElement("div", { className: styles.body },
                React.createElement("div", { className: styles.info }, "Loading medication..."),
                React.createElement(ColorLinearProgress, { className: styles.progress }))) })) : (React.createElement(EditMedicationDialog, { currentProvider: currentProvider, patientMedication: patientMedication, patient: props.patient, encounter: props.encounter, service: props.service, controlledMedicationHandler: props.controlledMedicationHandler, getDefaultViewingRight: props.getDefaultViewingRight, onCancel: function () { return props.onCancel(); }, onUpdate: function () { return props.onUpdate(); } }));
};
